import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { LIVE_CHAT_UNAVAILABLE_EVENT } from '../../utils/liveChat';
import { useToasts } from './Toast';

/**
 * Live chat is a third-party widget and is routinely blocked by corporate egress filtering
 * and ad blockers. When it is, every "Live Chat" control in the app is a dead button, so
 * surface the email fallback rather than leaving the click unanswered.
 */
const LiveChatUnavailableToast: React.FC = () => {
  const $ = _c(3);
  const {
    addToast
  } = useToasts();
  let t0;
  let t1;
  if ($[0] !== addToast) {
    t0 = () => {
      const onUnavailable = () => addToast("error", "Live chat is unavailable \u2014 it may be blocked by your network. Email info@hookdeck.com instead.");
      window.addEventListener(LIVE_CHAT_UNAVAILABLE_EVENT, onUnavailable);
      return () => window.removeEventListener(LIVE_CHAT_UNAVAILABLE_EVENT, onUnavailable);
    };
    t1 = [addToast];
    $[0] = addToast;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
};
export default LiveChatUnavailableToast;